module.exports = {
    parent: 'parent',
    parentProperty: 'parentProperty',
    path: 'path',
    pointer: 'pointer',
    value: 'value'
};
